<div class="dialog-container">
  <div class="dialog-header">
    @if (step === 1) {
      <h1 class="dialog-title">Importador de Produtos</h1>
    }
    @if (step === 2) {
      <h1 class="dialog-title">Pré-visualização da importação</h1>
    }

    <button mat-icon-button (click)="cancelar()" tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (step === 1) {
    <div class="dialog-content">
      <div class="actions-row">
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" hidden />
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          (click)="fileInput.click()"
          [disabled]="isLoading">
          @if (!isLoading) {
            <mat-icon class="material-symbols-outlined">upload</mat-icon>
          }
          @if (isLoading) {
            <mat-spinner diameter="20"></mat-spinner>
          }
          {{ isLoading ? '' : 'Carregar planilha de produtos' }}
        </button>
        <button mat-button (click)="downloadModelo()">
          <mat-icon class="material-symbols-outlined">download</mat-icon>
          Download da planilha de exemplo
        </button>
      </div>
      <p class="instructions-text">
        Serão considerados os campos ID ou Código (SKU) para atualizar um produto já existente.<br />
        Selecione um arquivo no formato texto (.csv) separado por ";".<br />
        O arquivo deverá ser compatível com o layout fornecido pela ATS.<br />
        O tamanho do arquivo não deve ultrapassar 2Mb.
      </p>
      @if (errorMessage) {
        <mat-error class="mb-3 d-block">
          <mat-icon class="align-middle">error</mat-icon> {{ errorMessage }}
        </mat-error>
      }
      <div class="table-section">
        <h3 class="table-title">Exemplo de planilha compatível com o Sistema ERP</h3>
        <div class="table-container">
          <table mat-table [dataSource]="dataSourceExample">
            <ng-container matColumnDef="idProduto">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let e">{{ e.idProduto }}</td>
            </ng-container>
            <ng-container matColumnDef="codigoSku">
              <th mat-header-cell *matHeaderCellDef>Código (SKU)</th>
              <td mat-cell *matCellDef="let e">{{ e.codigoSku }}</td>
            </ng-container>
            <ng-container matColumnDef="descricao">
              <th mat-header-cell *matHeaderCellDef>Descrição</th>
              <td mat-cell *matCellDef="let e">{{ e.descricao }}</td>
            </ng-container>
            <ng-container matColumnDef="unidade">
              <th mat-header-cell *matHeaderCellDef>Unidade</th>
              <td mat-cell *matCellDef="let e">{{ e.unidade }}</td>
            </ng-container>
            <ng-container matColumnDef="ncm">
              <th mat-header-cell *matHeaderCellDef>NCM</th>
              <td mat-cell *matCellDef="let e">{{ e.ncm | mask: '0000.00.00' }}</td>
            </ng-container>
            <ng-container matColumnDef="origem">
              <th mat-header-cell *matHeaderCellDef>Origem</th>
              <td mat-cell *matCellDef="let e">{{ e.origem }}</td>
            </ng-container>
            <ng-container matColumnDef="preco">
              <th mat-header-cell *matHeaderCellDef>Preço</th>
              <td mat-cell *matCellDef="let e">{{ e.preco }}</td>
            </ng-container>
            <ng-container matColumnDef="valorIpiFixo">
              <th mat-header-cell *matHeaderCellDef>Valor IPI fixo</th>
              <td mat-cell *matCellDef="let e">{{ e.valorIpiFixo }}</td>
            </ng-container>
            <ng-container matColumnDef="observacoes">
              <th mat-header-cell *matHeaderCellDef>Observações</th>
              <td mat-cell *matCellDef="let e">{{ e.observacoes }}</td>
            </ng-container>
            <ng-container matColumnDef="situacao">
              <th mat-header-cell *matHeaderCellDef>Situação</th>
              <td mat-cell *matCellDef="let e">{{ e.situacao }}</td>
            </ng-container>
            <ng-container matColumnDef="precoCusto">
              <th mat-header-cell *matHeaderCellDef>Preço de custo</th>
              <td mat-cell *matCellDef="let e">{{ e.precoCusto }}</td>
            </ng-container>
            <ng-container matColumnDef="codigoFornecedor">
              <th mat-header-cell *matHeaderCellDef>Cód. Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.codigoFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="cpfFornecedor">
              <th mat-header-cell *matHeaderCellDef>CPF Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.cpfFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="cnpjFornecedor">
              <th mat-header-cell *matHeaderCellDef>CNPJ Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.cnpjFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="docEstrangeiroFornecedor">
              <th mat-header-cell *matHeaderCellDef>Doc. Estr. Forn.</th>
              <td mat-cell *matCellDef="let e">{{ e.docEstrangeiroFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="paisFornecedor">
              <th mat-header-cell *matHeaderCellDef>País Fornecedor</th>
              <td mat-cell *matCellDef="let e">{{ e.paisFornecedor }}</td>
            </ng-container>
            <ng-container matColumnDef="pesoLiquido">
              <th mat-header-cell *matHeaderCellDef>Peso Líquido</th>
              <td mat-cell *matCellDef="let e">{{ e.pesoLiquido }}</td>
            </ng-container>
            <ng-container matColumnDef="pesoBruto">
              <th mat-header-cell *matHeaderCellDef>Peso Bruto</th>
              <td mat-cell *matCellDef="let e">{{ e.pesoBruto }}</td>
            </ng-container>
            <ng-container matColumnDef="gtinEan">
              <th mat-header-cell *matHeaderCellDef>GTIN/EAN</th>
              <td mat-cell *matCellDef="let e">{{ e.gtinEan }}</td>
            </ng-container>
            <ng-container matColumnDef="gtinTributavel">
              <th mat-header-cell *matHeaderCellDef>GTIN Tributável</th>
              <td mat-cell *matCellDef="let e">{{ e.gtinTributavel }}</td>
            </ng-container>
            <ng-container matColumnDef="descricaoComplementar">
              <th mat-header-cell *matHeaderCellDef>Desc. Complementar</th>
              <td mat-cell *matCellDef="let e">{{ e.descricaoComplementar }}</td>
            </ng-container>
            <ng-container matColumnDef="cest">
              <th mat-header-cell *matHeaderCellDef>CEST</th>
              <td mat-cell *matCellDef="let e">{{ e.cest | mask: '00.000.00' }}</td>
            </ng-container>
            <ng-container matColumnDef="codigoEnquadramentoIpi">
              <th mat-header-cell *matHeaderCellDef>Cód. Enquad. IPI</th>
              <td mat-cell *matCellDef="let e">{{ e.codigoEnquadramentoIpi }}</td>
            </ng-container>
            <ng-container matColumnDef="largura">
              <th mat-header-cell *matHeaderCellDef>Largura (cm)</th>
              <td mat-cell *matCellDef="let e">{{ e.largura }}</td>
            </ng-container>
            <ng-container matColumnDef="altura">
              <th mat-header-cell *matHeaderCellDef>Altura (cm)</th>
              <td mat-cell *matCellDef="let e">{{ e.altura }}</td>
            </ng-container>
            <ng-container matColumnDef="comprimento">
              <th mat-header-cell *matHeaderCellDef>Comprimento (cm)</th>
              <td mat-cell *matCellDef="let e">{{ e.comprimento }}</td>
            </ng-container>
            <ng-container matColumnDef="diametro">
              <th mat-header-cell *matHeaderCellDef>Diâmetro (cm)</th>
              <td mat-cell *matCellDef="let e">{{ e.diametro }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoProduto">
              <th mat-header-cell *matHeaderCellDef>Tipo Produto</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoProduto }}</td>
            </ng-container>
            <ng-container matColumnDef="categoria">
              <th mat-header-cell *matHeaderCellDef>Categoria</th>
              <td mat-cell *matCellDef="let e">{{ e.categoria }}</td>
            </ng-container>
            <ng-container matColumnDef="codigoSkuPai">
              <th mat-header-cell *matHeaderCellDef>SKU do Pai</th>
              <td mat-cell *matCellDef="let e">{{ e.codigoSkuPai }}</td>
            </ng-container>
            <ng-container matColumnDef="variacoes">
              <th mat-header-cell *matHeaderCellDef>Variações</th>
              <td mat-cell *matCellDef="let e">{{ e.variacoes }}</td>
            </ng-container>
            <ng-container matColumnDef="marca">
              <th mat-header-cell *matHeaderCellDef>Marca</th>
              <td mat-cell *matCellDef="let e">{{ e.marca }}</td>
            </ng-container>
            <ng-container matColumnDef="garantia">
              <th mat-header-cell *matHeaderCellDef>Garantia</th>
              <td mat-cell *matCellDef="let e">{{ e.garantia }}</td>
            </ng-container>
            <ng-container matColumnDef="sobEncomenda">
              <th mat-header-cell *matHeaderCellDef>Sob Encomenda</th>
              <td mat-cell *matCellDef="let e">{{ e.sobEncomenda }}</td>
            </ng-container>
            <ng-container matColumnDef="linkVideo">
              <th mat-header-cell *matHeaderCellDef>Link Vídeo</th>
              <td mat-cell *matCellDef="let e">{{ e.linkVideo }}</td>
            </ng-container>
            <ng-container matColumnDef="tituloSeo">
              <th mat-header-cell *matHeaderCellDef>Título SEO</th>
              <td mat-cell *matCellDef="let e">{{ e.tituloSeo }}</td>
            </ng-container>
            <ng-container matColumnDef="descricaoSeo">
              <th mat-header-cell *matHeaderCellDef>Descrição SEO</th>
              <td mat-cell *matCellDef="let e">{{ e.descricaoSeo }}</td>
            </ng-container>
            <ng-container matColumnDef="palavrasChaveSeo">
              <th mat-header-cell *matHeaderCellDef>Palavras-chave SEO</th>
              <td mat-cell *matCellDef="let e">{{ e.palavrasChaveSeo }}</td>
            </ng-container>
            <ng-container matColumnDef="slug">
              <th mat-header-cell *matHeaderCellDef>Slug</th>
              <td mat-cell *matCellDef="let e">{{ e.slug }}</td>
            </ng-container>
            <ng-container matColumnDef="diasPreparacao">
              <th mat-header-cell *matHeaderCellDef>Dias Preparação</th>
              <td mat-cell *matCellDef="let e">{{ e.diasPreparacao }}</td>
            </ng-container>
            <ng-container matColumnDef="controlarLotes">
              <th mat-header-cell *matHeaderCellDef>Controlar Lotes</th>
              <td mat-cell *matCellDef="let e">{{ e.controlarLotes }}</td>
            </ng-container>
            <ng-container matColumnDef="controlarSeries">
              <th mat-header-cell *matHeaderCellDef>Controlar Séries</th>
              <td mat-cell *matCellDef="let e">{{ e.controlarSeries }}</td>
            </ng-container>
            <ng-container matColumnDef="unidadePorCaixa">
              <th mat-header-cell *matHeaderCellDef>Unid/Caixa</th>
              <td mat-cell *matCellDef="let e">{{ e.unidadePorCaixa }}</td>
            </ng-container>
            <ng-container matColumnDef="markup">
              <th mat-header-cell *matHeaderCellDef>Markup</th>
              <td mat-cell *matCellDef="let e">{{ e.markup }}</td>
            </ng-container>
            <ng-container matColumnDef="permitirVenda">
              <th mat-header-cell *matHeaderCellDef>Permitir Venda</th>
              <td mat-cell *matCellDef="let e">{{ e.permitirVenda }}</td>
            </ng-container>
            <ng-container matColumnDef="exTipi">
              <th mat-header-cell *matHeaderCellDef>EX TIPI</th>
              <td mat-cell *matCellDef="let e">{{ e.exTipi }}</td>
            </ng-container>
            <ng-container matColumnDef="estoqueMinimo">
              <th mat-header-cell *matHeaderCellDef>Estoque Mínimo</th>
              <td mat-cell *matCellDef="let e">{{ e.estoqueMinimo }}</td>
            </ng-container>
            <ng-container matColumnDef="estoqueMaximo">
              <th mat-header-cell *matHeaderCellDef>Estoque Máximo</th>
              <td mat-cell *matCellDef="let e">{{ e.estoqueMaximo }}</td>
            </ng-container>
            <ng-container matColumnDef="tipoItemSped">
              <th mat-header-cell *matHeaderCellDef>Tipo item SPED</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoItemSped }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsExample"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsExample"></tr>
          </table>
        </div>
      </div>
    </div>
  }

  @if (step === 2) {
    <div class="dialog-content">
      <div class="validation-header mb-3">
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'todos'"
          (click)="aplicarFiltro('todos')">
          <span class="metric-label">todos</span>
          <strong class="metric-value">{{ getResumoTotal() }}</strong>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'novos'"
          (click)="aplicarFiltro('novos')">
          <span class="metric-label"><span class="dot dot-green"></span> novos</span>
          <span class="metric-value-sm">{{ getResumoNovos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'atualizados'"
          (click)="aplicarFiltro('atualizados')">
          <span class="metric-label"><span class="dot dot-blue"></span> atualizados</span>
          <span class="metric-value-sm">{{ getResumoAtualizados() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'avisos'"
          (click)="aplicarFiltro('avisos')">
          <span class="metric-label"><span class="dot dot-yellow"></span> advertências</span>
          <span class="metric-value-sm">{{ getResumoAvisos() }}</span>
        </div>
        <div
          class="metric-item clickable"
          [class.active-metric]="currentFilter === 'erros'"
          (click)="aplicarFiltro('erros')">
          <span class="metric-label"><span class="dot dot-red"></span> erros</span>
          <span class="metric-value-sm">{{ getResumoErros() }}</span>
        </div>
      </div>
      <div class="table-container">
        <table mat-table [dataSource]="itemsFiltered">
          <ng-container matColumnDef="status" sticky>
            <th mat-header-cell *matHeaderCellDef class="w-status">Situação</th>
            <td
              mat-cell
              *matCellDef="let element"
              class="w-status"
              [matTooltip]="getTooltip(element)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              <div class="status-dots">
                @if (element.acao === _acaoImportacaoEnum.Novo) {
                  <span class="dot dot-green"></span>
                }
                @if (element.acao === _acaoImportacaoEnum.Atualizar) {
                  <span class="dot dot-blue"></span>
                }
                @if (!element.isValido) {
                  <span class="dot dot-red"></span>
                }
                @if (element.isAlerta && element.isValido) {
                  <span class="dot dot-yellow"></span>
                }
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="idProduto">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.idProduto }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoSku">
            <th mat-header-cell *matHeaderCellDef>Código (SKU)</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoSku }}
            </td>
          </ng-container>
          <ng-container matColumnDef="descricao">
            <th mat-header-cell *matHeaderCellDef>Descrição</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.descricao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="unidade">
            <th mat-header-cell *matHeaderCellDef>Unidade</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.unidade }}
            </td>
          </ng-container>
          <ng-container matColumnDef="ncm">
            <th mat-header-cell *matHeaderCellDef>NCM</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.ncm | mask: '0000.00.00' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="origem">
            <th mat-header-cell *matHeaderCellDef>Origem</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.origem }}
            </td>
          </ng-container>
          <ng-container matColumnDef="preco">
            <th mat-header-cell *matHeaderCellDef>Preço</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.preco }}
            </td>
          </ng-container>
          <ng-container matColumnDef="valorIpiFixo">
            <th mat-header-cell *matHeaderCellDef>Valor IPI fixo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.valorIpiFixo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="observacoes">
            <th mat-header-cell *matHeaderCellDef>Observações</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.observacoes }}
            </td>
          </ng-container>
          <ng-container matColumnDef="situacao">
            <th mat-header-cell *matHeaderCellDef>Situação</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.situacao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="precoCusto">
            <th mat-header-cell *matHeaderCellDef>Preço de custo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.precoCusto }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoFornecedor">
            <th mat-header-cell *matHeaderCellDef>Cód. Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cpfFornecedor">
            <th mat-header-cell *matHeaderCellDef>CPF Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cpfFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cnpjFornecedor">
            <th mat-header-cell *matHeaderCellDef>CNPJ Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cnpjFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="docEstrangeiroFornecedor">
            <th mat-header-cell *matHeaderCellDef>Doc. Estr. Forn.</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.docEstrangeiroFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="paisFornecedor">
            <th mat-header-cell *matHeaderCellDef>País Fornecedor</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.paisFornecedor }}
            </td>
          </ng-container>
          <ng-container matColumnDef="pesoLiquido">
            <th mat-header-cell *matHeaderCellDef>Peso Líquido</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.pesoLiquido }}
            </td>
          </ng-container>
          <ng-container matColumnDef="pesoBruto">
            <th mat-header-cell *matHeaderCellDef>Peso Bruto</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.pesoBruto }}
            </td>
          </ng-container>
          <ng-container matColumnDef="gtinEan">
            <th mat-header-cell *matHeaderCellDef>GTIN/EAN</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.gtinEan }}
            </td>
          </ng-container>
          <ng-container matColumnDef="gtinTributavel">
            <th mat-header-cell *matHeaderCellDef>GTIN Tributável</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.gtinTributavel }}
            </td>
          </ng-container>
          <ng-container matColumnDef="descricaoComplementar">
            <th mat-header-cell *matHeaderCellDef>Desc. Complementar</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.descricaoComplementar }}
            </td>
          </ng-container>
          <ng-container matColumnDef="cest">
            <th mat-header-cell *matHeaderCellDef>CEST</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.cest | mask: '00.000.00' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoEnquadramentoIpi">
            <th mat-header-cell *matHeaderCellDef>Cód. Enquad. IPI</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoEnquadramentoIpi }}
            </td>
          </ng-container>
          <ng-container matColumnDef="largura">
            <th mat-header-cell *matHeaderCellDef>Largura (cm)</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.largura }}
            </td>
          </ng-container>
          <ng-container matColumnDef="altura">
            <th mat-header-cell *matHeaderCellDef>Altura (cm)</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.altura }}
            </td>
          </ng-container>
          <ng-container matColumnDef="comprimento">
            <th mat-header-cell *matHeaderCellDef>Comprimento (cm)</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.comprimento }}
            </td>
          </ng-container>
          <ng-container matColumnDef="diametro">
            <th mat-header-cell *matHeaderCellDef>Diâmetro (cm)</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.diametro }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tipoProduto">
            <th mat-header-cell *matHeaderCellDef>Tipo Produto</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tipoProduto }}
            </td>
          </ng-container>
          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef>Categoria</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.categoria }}
            </td>
          </ng-container>
          <ng-container matColumnDef="codigoSkuPai">
            <th mat-header-cell *matHeaderCellDef>SKU do Pai</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.codigoSkuPai }}
            </td>
          </ng-container>
          <ng-container matColumnDef="variacoes">
            <th mat-header-cell *matHeaderCellDef>Variações</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.variacoes }}
            </td>
          </ng-container>
          <ng-container matColumnDef="marca">
            <th mat-header-cell *matHeaderCellDef>Marca</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.marca }}
            </td>
          </ng-container>
          <ng-container matColumnDef="garantia">
            <th mat-header-cell *matHeaderCellDef>Garantia</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.garantia }}
            </td>
          </ng-container>
          <ng-container matColumnDef="sobEncomenda">
            <th mat-header-cell *matHeaderCellDef>Sob Encomenda</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.sobEncomenda }}
            </td>
          </ng-container>
          <ng-container matColumnDef="linkVideo">
            <th mat-header-cell *matHeaderCellDef>Link Vídeo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.linkVideo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tituloSeo">
            <th mat-header-cell *matHeaderCellDef>Título SEO</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tituloSeo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="descricaoSeo">
            <th mat-header-cell *matHeaderCellDef>Descrição SEO</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.descricaoSeo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="palavrasChaveSeo">
            <th mat-header-cell *matHeaderCellDef>Palavras-chave SEO</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.palavrasChaveSeo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="slug">
            <th mat-header-cell *matHeaderCellDef>Slug</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.slug }}
            </td>
          </ng-container>
          <ng-container matColumnDef="diasPreparacao">
            <th mat-header-cell *matHeaderCellDef>Dias Preparação</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.diasPreparacao }}
            </td>
          </ng-container>
          <ng-container matColumnDef="controlarLotes">
            <th mat-header-cell *matHeaderCellDef>Controlar Lotes</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.controlarLotes }}
            </td>
          </ng-container>
          <ng-container matColumnDef="controlarSeries">
            <th mat-header-cell *matHeaderCellDef>Controlar Séries</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.controlarSeries }}
            </td>
          </ng-container>
          <ng-container matColumnDef="unidadePorCaixa">
            <th mat-header-cell *matHeaderCellDef>Unid/Caixa</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.unidadePorCaixa }}
            </td>
          </ng-container>
          <ng-container matColumnDef="markup">
            <th mat-header-cell *matHeaderCellDef>Markup</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.markup }}
            </td>
          </ng-container>
          <ng-container matColumnDef="permitirVenda">
            <th mat-header-cell *matHeaderCellDef>Permitir Venda</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.permitirVenda }}
            </td>
          </ng-container>
          <ng-container matColumnDef="exTipi">
            <th mat-header-cell *matHeaderCellDef>EX TIPI</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.exTipi }}
            </td>
          </ng-container>
          <ng-container matColumnDef="estoqueMinimo">
            <th mat-header-cell *matHeaderCellDef>Estoque Mínimo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.estoqueMinimo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="estoqueMaximo">
            <th mat-header-cell *matHeaderCellDef>Estoque Máximo</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.estoqueMaximo }}
            </td>
          </ng-container>
          <ng-container matColumnDef="tipoItemSped">
            <th mat-header-cell *matHeaderCellDef>Tipo item SPED</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.tipoItemSped }}
            </td>
          </ng-container>
          <ng-container matColumnDef="linha">
            <th mat-header-cell *matHeaderCellDef>Linha</th>
            <td
              mat-cell
              *matCellDef="let e"
              [matTooltip]="getTooltip(e)"
              matTooltipClass="multiline-tooltip"
              [matTooltipPosition]="'above'">
              {{ e.dadosOriginais.linha }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsPreview"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumnsPreview"
            [ngClass]="getRowClass(row)"></tr>
        </table>
        @if (itemsFiltered.length === 0) {
          <div class="empty-state p-4 text-center text-muted">Nenhum item encontrado neste filtro.</div>
        }
      </div>
    </div>
  }

  <div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
    <div class="actions-wrapper">
      @if (step === 1) {
        <button mat-stroked-button class="btn-secondary me-2 mobile-full-width" (click)="cancelar()">
          Cancelar
        </button>
      }

      @if (step === 2) {
        <button mat-stroked-button class="btn-secondary" (click)="voltarParaUpload()">
          <mat-icon>refresh</mat-icon> escolher outro arquivo
        </button>
        <div
          class="button-tooltip-wrapper mobile-full-width"
          [matTooltip]="getButtonTooltip()"
          [matTooltipDisabled]="!isImportDisabled">
          <button
            mat-flat-button
            class="btn-primary w-100"
            [disabled]="isImportDisabled || isLoading"
            (click)="confirmarImportacao()">
            @if (isLoading === true) {
              <mat-spinner [diameter]="20"></mat-spinner>
            } @else {
              <span class="material-symbols-outlined">check</span> meus dados estão corretos
            }
          </button>
        </div>
      }
    </div>
  </div>
</div>
